<div class="healthcareLeader">
  <h1>Inmar Healthcare Solutions</h1>
  <h2>Maximize Profitability. Reduce Costs. Drive Business Intelligence.</h2>
  <div>
      <span>Driving profitability, risk mitigation, and operational efficiency
        through business intelligence and workplace solutions for pharmacies,
        health systems, and manufacturers.</span>
  </div>
</div>
